module.exports = __webpack_public_path__ + "static/media/TLewis_CV.ec229945.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/Media/resume/TLewis_CV.pdf
// module id = 34
// module chunks = 0